export default {"src":"/_next/static/media/icn-arrow-right.51cb134d.svg","height":24,"width":24};